module.exports = __webpack_public_path__ + "820f4a4af8daea1a0f99f21c98fda8e5.mp3";